// extracted by mini-css-extract-plugin
var _1 = "'{\"sm\": \"640px\", \"md\": \"1024px\", \"lg\": \"1240px\"}'";
export { _1 as "helpCenterBreakpoints" }
